import {
  HeroSection,
  FeaturesSection,
  ModelsSection,
  CtaSection,
} from "@/components/product/agent-studio"
import { FooterSection } from "@/components/home/footer"
import { usePageTitle } from "@/hooks/use-page-title"

/**
 * Agent Studio product page.
 * Showcases the agent builder interface and its capabilities.
 */
export function AgentStudioPage() {
  const pageTitle = usePageTitle(
    "Agent Studio",
    "Build powerful AI agents with our intuitive visual builder. Create, customize, and deploy intelligent agents in minutes - no coding required."
  )

  return (
    <div className="w-full">
      {pageTitle}
      <HeroSection />
      <FeaturesSection />
      <ModelsSection />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

AgentStudioPage.displayName = "AgentStudioPage"
